// extracted by mini-css-extract-plugin
export default {"mainCont":"ActivateExcel_mainCont__MyjwB","rsCont":"ActivateExcel_rsCont__tu8ve","btnCont":"ActivateExcel_btnCont__k66Ex","rsItem":"ActivateExcel_rsItem__w-7ty"};